import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'analytics-test-error';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const CLEANUP_TEST_ERROR = `${NAMESPACE}/CLEANUP_TEST_ERROR`;
export const GET_AGGREGATED_TEST_ERRORS = createApiNamespacedConstants('GET_AGGREGATED_TEST_ERRORS');
export const GET_TESTS_BY_ERROR = createApiNamespacedConstants('GET_TESTS_BY_ERROR');
